"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var material_1 = require("@mui/material");
var _1 = require(".");
var QrCodeOnImage = __importStar(require("./M_QrCodeOnImage"));
/** A modal containing a QR Code, an explanation and an image
 *
 * created for AR Runway, kinda specific, avoid reuse */
var Component = function (p) {
    return (Preact.h(_1.DrawerWithTitle.Component, { platform: p.platform, portrait: p.portrait, title: p.title, onClose: p.onClose, open: p.open, sx: p.sx },
        Preact.h(QrCodeOnImage.Component, { url: p.url, imageSrc: p.imageSrc, qrHintText: p.qrHintText }),
        Preact.h(material_1.Typography, { variant: "h5", textAlign: "center" }, p.body)));
};
exports.Component = Component;
